import type { ReportPeriod } from "./types";

export const REPORT_PERIOD_OPTIONS: { value: ReportPeriod; label: string }[] = [
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-30-days", label: "Last 30 days" },
  { value: "this-month", label: "This month" },
  { value: "this-quarter", label: "This quarter" },
  { value: "since-90-days-ago", label: "Since 90 days ago" },
  { value: "ytd", label: "Year to date" },
  { value: "all-dates", label: "All dates" },
  { value: "custom", label: "Custom" },
];

export const QR_COLUMN_KEYS = [
  "distributionAccount",
  "date",
  "type",
  "refNo",
  "payee",
  "description",
  "accountName",
  "cleared",
  "amount",
  "balance",
] as const;

export type QRColumnKey = typeof QR_COLUMN_KEYS[number];

export const QR_COLUMN_LABELS: Record<QRColumnKey, string> = {
  distributionAccount: "Distribution account",
  date: "Date",
  type: "Type",
  refNo: "Ref no",
  payee: "Payee",
  description: "Description",
  accountName: "Account",
  cleared: "Cleared",
  amount: "Amount",
  balance: "Balance",
};

export const QR_COL_WIDTHS: Partial<Record<QRColumnKey, number>> = {
  distributionAccount: 150,
  date: 100,
  type: 95,
  refNo: 60,
  accountName: 140,
  cleared: 80,
  amount: 100,
  balance: 110,
};

export const QR_COL_ALIGN: Partial<Record<QRColumnKey, "right">> = {
  amount: "right",
  balance: "right",
};

export const CUSTOM_REPORTS_STORAGE_KEY = "novala.customReports";
export const DEFAULT_PERIOD: ReportPeriod = "since-90-days-ago";